import { jsx, jsxs } from "react/jsx-runtime";
import RadioButtonOn from "@crehana/compass.icons.fill/RadioButtonOn";
import RadioButtonOff from "@crehana/compass.icons.outline/RadioButtonOff";
import { clsx } from "clsx";
import { getRadioColors } from "./utils.js";
const Radio = ({ checked = false, onChange, disabled = false, title, subtitle, error, errorMessage, className = '', size = 'm', inputElProps, ...otherProps })=>{
    const radioIconColors = getRadioColors(disabled, checked, errorMessage, error);
    return /*#__PURE__*/ jsxs("label", {
        className: clsx('tw-inline-flex tw-items-center tw-justify-center tw-relative', 'tw-gap-1.2', disabled ? 'tw-pointer-events-none' : 'tw-cursor-pointer', radioIconColors, className),
        ...otherProps,
        children: [
            /*#__PURE__*/ jsx("input", {
                ...inputElProps,
                className: "tw-opacity-0 tw-absolute tw-inset-0",
                style: {
                    zIndex: '-1'
                },
                type: "checkbox",
                disabled: disabled,
                onChange: onChange
            }),
            checked && !disabled ? /*#__PURE__*/ jsx(RadioButtonOn, {
                className: clsx('tw-h-2.4 tw-w-2.4 tw-min-h-[2.4rem] tw-min-w-[2.4rem]', 'tw-cursor-pointer tw-transition-colors')
            }) : /*#__PURE__*/ jsx(RadioButtonOff, {
                className: clsx('tw-h-2.4 tw-w-2.4 tw-min-h-[2.4rem] tw-min-w-[2.4rem]', 'tw-transition-colors')
            }),
            title && (title || subtitle || errorMessage) && /*#__PURE__*/ jsxs("span", {
                className: "tw-inline-grid",
                children: [
                    title && /*#__PURE__*/ jsx("span", {
                        className: clsx('m' === size ? 'tw-font-subtitle5' : 'tw-font-caption', disabled ? 'tw-text-neutral-light-500' : 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100'),
                        children: title
                    }),
                    subtitle && 'm' === size && /*#__PURE__*/ jsx("span", {
                        className: clsx('tw-font-body5', disabled ? 'tw-text-neutral-light-500' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500'),
                        children: subtitle
                    }),
                    errorMessage && /*#__PURE__*/ jsx("span", {
                        className: clsx('tw-font-caption', disabled ? 'tw-text-neutral-light-500' : 'tw-text-alert-500'),
                        children: errorMessage
                    })
                ]
            })
        ]
    });
};
const Radio_Radio = Radio;
export default Radio_Radio;
